import axios from 'axios'
import Qs from 'qs'
import store from '@/store'
import config from '@/utils/config'

const apiBug = axios.create({
  baseURL: config.urlEfacturaBugReport,
  paramsSerializer: array => Qs.stringify(array, {
    arrayFormat: 'repeat'
  }),
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  timeout: 30000,
  data: {}
})

export const getArray = (url, params = undefined) => {
  return new Promise((resolve, reject) => {
    if (params) Object.keys(params).forEach(key => !params[key] ? delete params[key] : {})
    apiBug.get(url, {
      params,
      data: {}
    }).then((res) => {
      resolve(res)
    }, (err) => {
      // Ignore 404 error when array is search, empty array is return
      if (err.request.status === 404) {
        store.dispatch('errors/empty')
        resolve({ data: [], headers: {} })
      }
      reject(err)
    })
  })
}

export const get = (url, params = undefined) => {
  return new Promise((resolve, reject) => {
    if (params) Object.keys(params).forEach(key => !params[key] ? delete params[key] : {})
    apiBug.get(url, {
      params,
      data: {}
    }).then((res) => {
      if (res.data && typeof res.data !== 'object') {
        reject(new Error('Error de conexión'))
        return
      }
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}

export const post = (url, body, params = {}) => {
  return new Promise((resolve, reject) => {
    let requestParams = {
      params
    }
    let headers = params.headers
    if (headers) {
      delete requestParams.params.headers
      requestParams.headers = headers
    }
    apiBug.post(url, body, requestParams).then((res) => {
      if (res.data && typeof res.data !== 'object') {
        reject(new Error('Error de conexión'))
        return
      }
      resolve(res)
    }, (err) => {
      reject(err)
    })
  })
}

export default apiBug
